// initial state
import axiosApi from '../../axiosApi'

const state = {
  list: [],
  mainSearch: {
    cat: null,
    filter: [],
    name: null
  },
  favorite: false
}

// getters
const getters = {
  getList: (state) => {
    return state.list
  }
}

// actions
const actions = {
  listWithSubCategories ({commit}, payload) {
    return axiosApi.get(`/categories/listWithSubCategories`)
      .then(response => {
        if (payload && payload.changeListState) {
          commit('SET_LIST', {list: response.data.categories})
        }
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  listWithSubCategoriesForAdmin ({commit}, payload) {
    return axiosApi.get(`/categories/listWithSubCategoriesForAdmin`)
      .then(response => {
        if (payload && payload.changeListState) {
          commit('SET_LIST', {list: response.data.categories})
        }
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  clearList ({commit, state}, payload) {
    commit('SET_LIST', {})
  },
  add ({commit, state}, payload) {
    return axiosApi.post(`/categories/add`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  edit ({commit, state}, payload) {
    return axiosApi.put(`/categories/edit/${payload.id}`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  delete ({commit, state}, payload) {
    return axiosApi.delete(`/categories/delete/${payload.categoryId}`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  changeStatus ({commit, state}, payload) {
    return axiosApi.post(`/categories/changeStatus`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  changeVisibility ({commit, state}, payload) {
    return axiosApi.post(`/categories/changeVisibility`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  mergeCategory ({commit, state}, payload) {
    return axiosApi.post(`/categories/mergeCategory`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  order ({commit, state}, payload) {
    return axiosApi.post(`/categories/order`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  setMainSearchData ({commit, state}, payload) {
    commit('SET_MAIN_SEARCH', payload)
  },
  setFavorite ({commit, state}, payload) {
    commit('SET_FAVORITE', payload)
  },
  setSearch ({commit, state}, payload) {
    commit('SET_SEARCH', payload)
  }
}

// mutations
const mutations = {
  SET_LIST (state, payload) {
    state.list = payload.list
  },
  SET_MAIN_SEARCH (state, payload) {
    state.mainSearch.cat = payload.cat || null
    state.mainSearch.filter = payload.filter || []
  },
  SET_FAVORITE (state, payload) {
    state.favorite = payload.favorite || false
  },
  SET_SEARCH (state, payload) {
    state.mainSearch.name = payload.name || null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/categories.js